<template>
  <div class="breadcrumb__container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item v-for="(item, i) in breadcrumbs" :key="i" class="breadcrumb__link">
        <router-link v-if="item.url" :to="item.url"> {{ item.title }} </router-link>
        <span v-else>{{ item.title }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'ComponentBreadcrumbs',

  props: {
    config: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      breadcrumbs: [],
    };
  },

  computed: {
    activeSidebarItem() {
      return store.state.activeSidebarItem;
    },
  },

  watch: {
    activeSidebarItem(value) {
      let path = [];
      if (value) path = this.getPagePath(value);
      this.breadcrumbs = path.map((crumb) => {
        if (crumb.title === 'Справочники'){
          return {title: crumb.title, url: '/datapage/catalog'}
        }
        if (crumb.title === 'Список задач'){
          return {title: crumb.title, url: '/page/FNSClassesConfigurationLink'}
        }
        if (crumb.title === 'Список задач для методолога'){
          return {title: crumb.title, url: '/page/FNSClassesConfigurationLinkExpert'}
        }
        return {title: crumb.title, url: ''}
      });
    },
  },

  methods: {
    getPagePath(item, path = []) {
      if (item.parent && item.parent.type !== 'root') this.getPagePath(item.parent, path);
      path.push(item);
      return path;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  &__link {
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
